/**
 * Returns the latest added non-upsell line item.
 */
export function getAddedLineItem<LineItem extends LineItemBase>(params: Params<LineItem>) {
  const { cartLineItems, upsellProducts } = params;

  const checkIfLineItemIsUpsell = checkIfLineItemIsNotUpsellFactory<LineItem>(upsellProducts); // prettier-ignore
  const lineItemsWithoutUpsells = cartLineItems.filter(checkIfLineItemIsUpsell); // prettier-ignore
  const sortedLineItems = [...lineItemsWithoutUpsells].sort(compareIds);

  return sortedLineItems[0];
}

// ─── Helpers ─────────────────────────────────────────────────────────────────

function checkIfLineItemIsNotUpsellFactory<LineItem extends LineItemBase>(
  upsellProducts: UpsellProduct[],
) {
  const upsellProductIds = upsellProducts.map((product) => product.id);
  const upsellProductIdsSet = new Set(upsellProductIds);

  return (lineItem: LineItem) => !upsellProductIdsSet.has(lineItem.product.id);
}

function compareIds<LineItem extends LineItemBase>(lineItem: LineItem, nextLineItem: LineItem) {
  return nextLineItem.id.localeCompare(lineItem.id);
}
// ─── Types ───────────────────────────────────────────────────────────────────

type Params<LineItem extends LineItemBase> = {
  cartLineItems: ReadonlyArray<LineItem>;
  upsellProducts: UpsellProduct[];
};

type UpsellProduct = { id: string };

type LineItemBase = {
  id: string;
  product: { id: string };
};
